var $701c918a4653e946$exports = {};
$701c918a4653e946$exports = {
  "Clear search": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u0438\u0441\u043A"
};
export { $701c918a4653e946$exports as default };